import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-light',
  templateUrl: './magic-uses-light.component.html',
  styleUrls: ['./magic-uses-light.component.css']
})
export class MagicUsesLightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
